import { isDevelopment } from 'app/infrastructure/universal';
import get from 'lodash/get';

export const logSystemInfo = props => {
  if (!isDevelopment) {
    return;
  }
  console.group('System info:');
  console.table &&
    console.table(
      [
        { property: 'Username', value: get(props, 'userInfo.userName') },
        { property: 'Token', value: localStorage.getItem('sl:access_token') },
        { property: 'Locale', value: get(props, 'locale') },
        {
          property: 'Client UTC offset',
          value: get(props, 'settings.utcOffset'),
          details: '(in minutes)'
        },
        { property: 'API version', value: get(props, 'version') }
      ],
      ['property', 'value']
    );
  console.groupEnd();
};
